module.exports = __webpack_public_path__ + "static/media/32-5.aad47785.mp3";